import {
  Boxes,
  ClipboardCheck,
  FileCode2,
  Gauge,
  History,
  Image,
  Mail,
  MailX,
  Puzzle,
  ScrollText,
  Server,
  Zap,
  type LucideIcon,
} from 'lucide-react'
import type { PermissionName } from '@/auth/permissions'

export interface NavItem {
  label: string
  to:
    | '/'
    | '/review'
    | '/applications'
    | '/templates'
    | '/partials'
    | '/assets'
    | '/event-types'
    | '/messages'
    | '/timelines'
    | '/suppressions'
    | '/audit'
    | '/system'
  icon: LucideIcon
  /** Two-key shortcut, shown in tooltips and the command palette. */
  shortcut?: string
  /** Hide the item unless the user has this permission. */
  permission?: PermissionName
  /** A count shown beside the label: `proposals` is open proposals in the app scope. */
  badge?: 'proposals'
}

export interface NavGroup {
  label?: string
  items: NavItem[]
}

/** The sidebar, also used by the command palette's "Go to" section. */
export const NAV: NavGroup[] = [
  {
    items: [
      { label: 'Dashboard', to: '/', icon: Gauge, shortcut: 'g d' },
      { label: 'Review', to: '/review', icon: ClipboardCheck, shortcut: 'g r', badge: 'proposals' },
    ],
  },
  {
    label: 'Configure',
    items: [
      { label: 'Applications', to: '/applications', icon: Boxes, shortcut: 'g a' },
      { label: 'Templates', to: '/templates', icon: FileCode2, shortcut: 'g t' },
      { label: 'Partials', to: '/partials', icon: Puzzle, shortcut: 'g p' },
      { label: 'Assets', to: '/assets', icon: Image, shortcut: 'g f' },
      { label: 'Event types', to: '/event-types', icon: Zap, shortcut: 'g e' },
    ],
  },
  {
    label: 'Operate',
    items: [
      { label: 'Messages', to: '/messages', icon: Mail, shortcut: 'g m' },
      { label: 'Timelines', to: '/timelines', icon: History, shortcut: 'g k' },
      { label: 'Suppressions', to: '/suppressions', icon: MailX, shortcut: 'g s' },
    ],
  },
  {
    label: 'Administer',
    items: [
      {
        label: 'Audit log',
        to: '/audit',
        icon: ScrollText,
        permission: 'view_audit',
        shortcut: 'g l',
      },
      { label: 'System', to: '/system', icon: Server, shortcut: 'g y' },
    ],
  },
]

export const NAV_ITEMS: NavItem[] = NAV.flatMap((g) => g.items)
